<template>
  <div
    class="featured-cars-slider__item w-full h-full flex flex-col border rounded-sm overflow-hidden bg-white"
    :class="{ 'border-accent': !invertedColor, 'border-primary': invertedColor }"
  >
    <NuxtLink :to="getLocaleVehicleUrl(car as unknown as Vehicle)" class="featured-cars-slider__item__image w-full h-[228px]" :aria-label="`${car.make.name} ${car.model}`" :title="t('components.featured-cars.toCar')">
      <SharedPicture
        v-if="useVehicleImages(car)[0]"
        :media="useVehicleImages(car)[0]"
        loading="lazy"
        class="w-full h-full object-cover"
        imageClass="rounded-sm overflow-hidden"
        :alt="t('components.featured-cars.carPlaceholder')"
        width="303"
        height="228"
        :quality="85"
      />
      <img v-else src="/imgs/fallback-car-card-img_310x230.png" :alt="car.model" class="w-full h-full object-cover rounded-sm overflow-hidden" width="303" height="228" />
    </NuxtLink>
    <div class="featured-cars-slider__item-content flex flex-col flex-grow p-4 pt-2">
      <NuxtLink :to="getLocaleVehicleUrl(car as unknown as Vehicle)" :title="t('components.featured-cars.toCar')" class="text-medium-semibold mb-2 min-h-[3.375rem]"
        >{{ car.make.name }} {{ car.model }}</NuxtLink
      >
      <div class="flex items-end justify-between">
        <p class="text-small-normal">{{ car.body_style[0]?.name || 'N/A' }}</p>
        <p class="text-accent font-semibold text-[20px] font-chivo">{{ formatPrice(car.asking_price) }}</p>
      </div>

      <div class="featured-cars-slider__item-controls mt-auto pt-4 flex gap-4 items-center">
        <SharedIconButton v-if="!mounted" variant="accent" size="small" :aria-label="t('components.featured-cars.favorite')" :title="t('components.featured-cars.favorite')"
          ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M12 5.4811C10.9104 4.4792 9.48419 3.92314 8.00398 3.9231C7.22052 3.92391 6.44495 4.07966 5.72192 4.38136C4.99888 4.68307 4.34265 5.12479 3.79098 5.6811C1.43798 8.0441 1.43898 11.7401 3.79298 14.0931L11.125 21.4251C11.295 21.7241 11.623 21.9171 12 21.9171C12.1548 21.9156 12.3071 21.8778 12.4446 21.8068C12.5822 21.7357 12.7011 21.6334 12.792 21.5081L20.207 14.0931C22.561 11.7391 22.561 8.0441 20.205 5.6771C19.6536 5.12181 18.9979 4.68099 18.2756 4.37998C17.5532 4.07897 16.7785 3.9237 15.996 3.9231C14.5158 3.92334 13.0897 4.47937 12 5.4811ZM18.791 7.0911C20.354 8.6621 20.355 11.1161 18.793 12.6791L12 19.4721L5.20698 12.6791C3.64498 11.1161 3.64598 8.6621 5.20498 7.0951C5.96498 6.3391 6.95898 5.9231 8.00398 5.9231C9.04898 5.9231 10.039 6.3391 10.793 7.0931L11.293 7.5931C11.3858 7.68604 11.496 7.75978 11.6173 7.81009C11.7386 7.8604 11.8686 7.8863 12 7.8863C12.1313 7.8863 12.2614 7.8604 12.3827 7.81009C12.504 7.75978 12.6142 7.68604 12.707 7.5931L13.207 7.0931C14.719 5.5841 17.281 5.5881 18.791 7.0911Z"
              fill="currentColor"
            />
          </svg>
        </SharedIconButton>
        <!-- <SharedIconButton
          v-if="!mounted"
          variant="accent"
          size="small"
          :aria-label="t('components.featured-cars.track')"
          :title="t('components.featured-cars.track')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M12 17.8861L13 15.8861V10.7441C14.721 10.2971 16 8.74411 16 6.88611C16 4.68011 14.206 2.88611 12 2.88611C9.794 2.88611 8 4.68011 8 6.88611C8 8.74411 9.279 10.2971 11 10.7441V15.8861L12 17.8861ZM10 6.88611C10 5.78311 10.897 4.88611 12 4.88611C13.103 4.88611 14 5.78311 14 6.88611C14 7.98911 13.103 8.88611 12 8.88611C10.897 8.88611 10 7.98911 10 6.88611Z"
              fill="currentColor"
            />
            <path
              d="M16.267 11.4491L15.734 13.3771C18.325 14.0931 20 15.4701 20 16.8861C20 18.7781 16.715 20.8861 12 20.8861C7.285 20.8861 4 18.7781 4 16.8861C4 15.4701 5.675 14.0931 8.267 13.3761L7.734 11.4481C4.197 12.4261 2 14.5091 2 16.8861C2 20.2501 6.393 22.8861 12 22.8861C17.607 22.8861 22 20.2501 22 16.8861C22 14.5091 19.803 12.4261 16.267 11.4491Z"
              fill="currentColor"
            />
          </svg>
        </SharedIconButton> -->
        <SharedFavoriteCarButton :car-id="car.documentId" :car-detail="car as unknown as GraphQLCarDetail" />
        <!-- <ClientOnly>
          <SharedIconButton
            v-if="mounted"
            :variant="tracked ? 'accent-inverted' : 'accent'"
            size="small"
            :aria-label="tracked ? t('components.featured-cars.tracked') : t('components.featured-cars.track')"
            :title="tracked ? t('components.featured-cars.tracked') : t('components.featured-cars.track')"
            @click="emit('track-toggle', car.documentId)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M12 17.8861L13 15.8861V10.7441C14.721 10.2971 16 8.74411 16 6.88611C16 4.68011 14.206 2.88611 12 2.88611C9.794 2.88611 8 4.68011 8 6.88611C8 8.74411 9.279 10.2971 11 10.7441V15.8861L12 17.8861ZM10 6.88611C10 5.78311 10.897 4.88611 12 4.88611C13.103 4.88611 14 5.78311 14 6.88611C14 7.98911 13.103 8.88611 12 8.88611C10.897 8.88611 10 7.98911 10 6.88611Z"
                fill="currentColor"
              />
              <path
                d="M16.267 11.4491L15.734 13.3771C18.325 14.0931 20 15.4701 20 16.8861C20 18.7781 16.715 20.8861 12 20.8861C7.285 20.8861 4 18.7781 4 16.8861C4 15.4701 5.675 14.0931 8.267 13.3761L7.734 11.4481C4.197 12.4261 2 14.5091 2 16.8861C2 20.2501 6.393 22.8861 12 22.8861C17.607 22.8861 22 20.2501 22 16.8861C22 14.5091 19.803 12.4261 16.267 11.4491Z"
                fill="currentColor"
              />
            </svg>
          </SharedIconButton>
        </ClientOnly> -->

        <SharedButton
          class="ml-auto w-full"
          size="small"
          :label="t('components.featured-cars.toCar')"
          variant="primary"
          :title="t('components.featured-cars.toCar')"
          :to="getLocaleVehicleUrl(car as unknown as Vehicle)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { AllVehiclesVehicle } from '~/types/api';
  import type { StrapiMedia, Vehicle } from '~/types/strapi';
  import type { GraphQLCarDetail } from '~/types/graphql';

  const { getLocaleVehicleUrl } = useCustomLocaleRoute();
  const { t } = useI18n();
  withDefaults(
    defineProps<{
      car: AllVehiclesVehicle;
      index: number;
      tracked?: boolean;
      invertedColor?: boolean;
    }>(),
    {
      tracked: false,
      favorite: false,
      invertedColor: false,
    }
  );

  const emit = defineEmits<{
    (e: 'track-toggle', carId: string): void;
  }>();

  const formatPrice = (price: number) => {
    return `€${price.toLocaleString('de-DE', {
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };

  const mounted = ref(false);

  onMounted(() => {
    mounted.value = true;
  });
</script>

<style scoped lang="scss">
  .featured-cars-slider__item {
    transition: all 0.3s ease-in-out;
    @apply mt-[10px];
    &:hover {
      transform: translateY(-5px);
      @apply mt-[5px];
    }
  }
</style>
